// =========================================================================================@@
// Last Updated Date: Feb 27, 2023
// Last Updated By: Steven Yuen
// Status Level: 1
// ===========================================================================================

import React, { useRef } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { SearchIcon } from 'assets/icons'

const SearchInput = ({ onSubmit }) => {
   const inputRef = useRef()
   const history = useHistory()

   const handleKeyDown = (event) => {
      const inputValue = event.currentTarget.value

      if (event.key === 'Enter') {
         history.push(`/-/search/${inputValue}`)
         inputRef.current.value = ''

         if (onSubmit) {
            onSubmit()
         }
      }
   }

   return (
      <div className="relative flex w-full items-center h-full bg-stone-100 hover:bg-stone-200/50 rounded-lg px-3">
         <View
            position="absolute"
            top="0px"
            left="0px"
            bottom="0px"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            width="26px">
            <SearchIcon width="14px" height="14px" color="var(--inputTextColor)" />
         </View>
         <input
            ref={inputRef}
            onKeyDown={handleKeyDown}
            type="search"
            placeholder="Search"
            className="w-full h-10 pl-6 text-sm text-neutral-900 bg-transparent"
         />
      </div>
   )
}

SearchInput.propTypes = {
   onSubmit: PropTypes.func
}

SearchInput.defaultProps = {
   onSubmit: undefined
}

export default SearchInput
